import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { insertItem, patch } from '@ngxs/store/operators';
import { NotificationsActions } from './notifications.actions';
import { NotificationItem } from 'src/app/global/interfaces/notification-item';

export interface NotificationsStateModel {
  toasts: NotificationItem[];
}

const stateDefaults: NotificationsStateModel = {
  toasts: [],
};

@State<NotificationsStateModel>({
  name: 'Notifications',
  defaults: stateDefaults,
})
@Injectable()
export class NotificationState {
  
  @Action(NotificationsActions.Toast)
  toastSuccess(ctx: StateContext<NotificationsStateModel>, { message, severity }: NotificationsActions.Toast) {
    ctx.setState(
      patch({
        toasts: insertItem<NotificationItem>({ message, severity })
      })
    )
  }
}
